<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <div class="d-flex justify-content-between">
                    <pageaddheader :title="title" :title1="title1" />
                    <div>
                        <router-link to="user" class="btn btn-cancel">Kembali</router-link>
                    </div>
                </div>

                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="@/assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>


                            </div>
                            <!-- <div class="mt-2 " style="width: 200px;"> <vue-select :options="TipeList"
                                    v-model="tipeFilter" placeholder="None" required class="w-100" />

                            </div> -->

                            <!-- <div class="wordset">
                                <ul>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"><img
                                                src="@/assets/img/icons/pdf.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"><img
                                                src="@/assets/img/icons/excel.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"><img
                                                src="@/assets/img/icons/printer.svg" alt="img" /></a>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                        <!-- /Filter -->
                        <!-- <div class="card mb-0" id="filter_inputs" :style="{
                            display: filter ? 'block' : 'none',
                        }">
                            <div class="card-body pb-0">
                                <div class="row">
                                    <div class="col-lg-12 col-sm-12">
                                        <div class="row">
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Product" placeholder="Choose Product" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Choose" placeholder="Choose Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Category" placeholder="Choose Sub Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Brand" placeholder="Brand" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Price" placeholder="Price" />
                                                </div>
                                            </div>
                                            <div class="col-lg-1 col-sm-6 col-12">
                                                <div class="form-group">
                                                    <a class="btn btn-filters ms-auto"><img
                                                            src="@/assets/img/icons/search-whites.svg" alt="img" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- /Filter -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" :pagination="false" @change="onChange">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'menu'">
                                        <div class="productimgname">
                                            {{ record.menu }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'create'">
                                        <div class="productimgname">
                                            <input type="checkbox" v-model="record.create"
                                                @change="update(record.id, 'create', record.create)">
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'read'">
                                        <div class="productimgname">
                                            <input type="checkbox" v-model="record.read"
                                                @change="update(record.id, 'read', record.read)">
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'update'">
                                        <div class="productimgname">
                                            <input type="checkbox" v-model="record.update"
                                                @change="update(record.id, 'update', record.update)">
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'delete'">
                                        <div class="productimgname">
                                            <input type="checkbox" v-model="record.delete"
                                                @change="update(record.id, 'delete', record.delete)">
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'export'">
                                        <div class="productimgname">
                                            <input type="checkbox" v-model="record.export"
                                                @change="update(record.id, 'export', record.export)">
                                        </div>
                                    </template>
                                    <!-- <template v-else-if="column.key === 'action'">
                                        <router-link class="me-3" to="edituser" @click="edit(record);">
                                            <img src="@/assets/img/icons/edit.svg" alt="img" />
                                        </router-link>
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id, record.nama); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template> -->
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, AlertBottom } from "@/assets/js/function";

export default {
    data() {
        return {
            filter: false,
            title: "Daftar Akses User",
            title1: "Kelola akses user",
            items: [
                {
                    text: "Tambah Pengguna",
                    addname: "/adduser",
                },
            ],

            //data
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Nama Menu",
                    dataIndex: "menu",
                    key: "menu",
                    sorter: {
                        compare: (a, b) => {
                            a = a.menu.toLowerCase();
                            b = b.menu.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Lihat",
                    dataIndex: "read",
                    key: "read",
                    sorter: false,
                },
                {
                    title: "Tambah",
                    dataIndex: "create",
                    key: "create",
                    sorter: false,
                },

                {
                    title: "Perbaharui",
                    dataIndex: "update",
                    key: "update",
                    sorter: false,
                },
                {
                    title: "Hapus",
                    dataIndex: "delete",
                    key: "delete",
                    sorter: false,
                },
                {
                    title: "Ekspor",
                    dataIndex: "export",
                    key: "export",
                    sorter: false,
                },

                // {
                //     title: "Nama",
                //     dataIndex: "nama_lengkap",
                //     key: "nama_lengkap",
                //     sorter: {
                //         compare: (a, b) => {
                //             a = a.nama_lengkap.toLowerCase();
                //             b = b.nama_lengkap.toLowerCase();
                //             return a > b ? -1 : b > a ? 1 : 0;
                //         },
                //     },
                // },




                // {
                //     title: "Aksi",
                //     key: "action",
                //     sorter: false,
                // },
            ],

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",



            //filter
            query: "",
            tipeFilter: "ADMIN",
            TipeList: ["ADMIN", "FINANCE", "SUPERVISOR", "DRIVER"],

            id_users: 0,

            nama_lengkap: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        this.id_users = localStorage.getItem('currentData');
        this.title = this.title + " (" + localStorage.getItem('needData1') + ")";
        this.index();
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {
                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            return this.data.filter(item =>
                // item.nama_lengkap.toLowerCase().includes(lowerCaseQuery)
                item.menu.toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    watch: {
        'tipeFilter': {
            handler(newValue) {
                this.index();
            }
        }
    },
    methods: {
        show_izitoast() {
            AlertBottom('tessst');
        },
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },


        // showAlert() {
        //     // Use sweetalert2
        //     Swal.fire({
        //         title: "Are you sure?",
        //         text: "You won't be able to revert this!",
        //         showCancelButton: true,
        //         confirmButtonColor: "#043249",
        //         cancelButtonColor: "#d33",
        //         confirmButtonText: "Yes, delete it!",
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             Swal.fire("Deleted!", "Your file has been deleted.");
        //         }
        //     });
        // },

        index() {
            this.data = [];
            ShowLoading();

            let formData = new FormData();
            formData.append('id', this.id_users);

            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }
            // CloseLoading();
            // return false;

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'user_auth';
            } else {
                this.api = base_url + 'user_auth';
            }

            

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    console.log(response)
                    if (response.data.status == true) {
                        response.data.data.forEach((item, index) => {
                            let item_prepare = { no: (index + 1), menu: item.menu, id: item.id, id_users: item.id_users, create: this.checkValue(item.create), update: this.checkValue(item.update), read: this.checkValue(item.read), delete: this.checkValue(item.delete), export: this.checkValue(item.export) };
                            this.data.push(item_prepare);
                        });
                        CloseLoading();
                    }

                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });

        },
        checkValue(string) {
            if (string == 'AKTIF') {
                return true;
            } else {
                return false;
            }
        },
        checkValue2(boolean) {
            if (boolean == true) {
                return 'AKTIF';
            } else {
                return 'TIDAK';
            }
        },
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },
        update(id, menu, status) {
            ShowLoading();
            let formData = new FormData();
            formData.append("id", id);
            formData.append("id_users", this.id_users);
            formData.append("akses", menu);
            formData.append("status", this.checkValue2(status));

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'user_auth_update';
            } else {
                this.api = base_url + 'user_auth_update';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        CloseLoading();
                        AlertBottom(response.data.message);
                    }
                    if (response.data.status == false) {
                        const index = this.data.findIndex((record) => record.id === id);

                        this.data[index][menu] = !this.data[index][menu];
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });


        },
        terminate(id, nama) {
            this.id_terminate = id;
            this.nama_terminate = nama;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>

<style>
.ant-tooltip {
    display: none !important;
}
</style>